window.addEventListener("DOMContentLoaded", (event) => {

  document.querySelectorAll(".cartitems--list .cart-item").forEach( cartItem =>{
    
    cartItem.querySelectorAll(".commonBtn").forEach( btn =>{
      btn.addEventListener("click", ()=> {
        const input = cartItem.querySelector("#inputQuantity");
        const inpVal = Number(input.value);
        const isPlus = btn.classList.contains("btnPlus");
        const cartItemKey = cartItem.getAttribute("data-cartitem-key");
          
        if( isPlus ){
          const newValue = inpVal + 1;
          input.value = newValue;
          changeItemQuantity(cartItemKey, newValue, cartItem);
        }else if( inpVal > 1 ){
          const newValue = inpVal - 1;
          input.value = newValue;
          changeItemQuantity(cartItemKey, newValue, cartItem);
        }
      });
    });
  });

  function changeItemQuantity(key, quantity, cartItem) {
    axios.post("/cart/change.js",{
      id: key,
      quantity
    }).then((res)=>{ 
      const totalPrice = res.data.total_price;
      const item = res.data.items.find( item => item.key === key);
      cartItem.querySelector("[data-cartitem-total]").innerHTML = Shopify.formatMoney(item.final_line_price);
      document.querySelectorAll("[data-cart-total]").forEach( ct =>{
        ct.innerHTML = Shopify.formatMoney(totalPrice);
      });
      
    });
  }

  

});

